export const RACING_ORG_TYPE = 'racing';
export const INTERNAL_AMES_ORG_ID = 'efc3f8f8-dc54-4956-8f0f-db793885330a';

export function canSwitchWorkspaces(company) {
  return company?.id === INTERNAL_AMES_ORG_ID && company?.org_type !== RACING_ORG_TYPE;
}

export function isRacingOnly(company) {
  return company?.org_type === RACING_ORG_TYPE;
}

export function canAccessRacing(company) {
  return canSwitchWorkspaces(company) || company?.org_type === RACING_ORG_TYPE;
}

// Standard project/session IDs are not racing survey IDs; route those links to
// the racing project list instead of forwarding an incompatible record ID.
export function racingRedirect(company, pathname) {
  if (!isRacingOnly(company) || pathname === '/subscription-required') return null;
  if (pathname.startsWith('/settings')) return '/racing/settings';
  if (pathname === '/upload') return '/racing/upload';
  if (pathname.startsWith('/projects') || pathname.startsWith('/session')) return '/racing/projects';
  return '/racing';
}
